import { useCurrentOrg } from '@/app/entities/org/model/orgModel'
import { useBalance, useSubscription } from '@/app/entities/payment/model'
import { BalanceCard, GiftTokensCard, SubscriptionCard } from '@/app/entities/payment/ui'
import { AdditionalTokensCard } from '@/app/entities/payment/ui/AdditionalTokensCard'
import { trackSubscriptionSuccessIfPending } from '@/common/lib/yandexMetrica/paymentGoals'
import { useEffect } from 'react'

export const PaymentPage = () => {
    const { data: currentOrg, isLoading: isOrgLoading } = useCurrentOrg()
    const orgId = currentOrg?.id

    const { tokens, isLoading: isBalanceLoading, refetch: refetchBalance } = useBalance(orgId)
    const { subscription, refetch: refetchSubscription } = useSubscription(orgId)

    useEffect(() => {
        if (subscription?.status !== 'active') return
        trackSubscriptionSuccessIfPending()
    }, [subscription?.status])

    const handleClaimGift = () => {
        refetchBalance()
    }

    const handleSubscribeSuccess = () => {
        refetchSubscription()
        refetchBalance()
    }

    if (isOrgLoading) {
        return (
            <div className='col-start-1 col-span-10'>
                <div className='flex items-center justify-center h-96'>
                    <p className='text-lg text-pixorion-gray-2'>Загрузка...</p>
                </div>
            </div>
        )
    }

    return (
        <div className='col-start-1 col-span-10'>
            <div className='flex flex-col gap-2 w-full'>
                <div className='flex gap-2'>
                    <BalanceCard tokens={tokens} isLoading={isBalanceLoading} />
                    <GiftTokensCard hasName={true} hasLastName={true} hasPhone={true} onClaim={handleClaimGift} />
                </div>

                <SubscriptionCard onSubscribeSuccess={handleSubscribeSuccess} />
                <AdditionalTokensCard />
            </div>
        </div>
    )
}
